export default __webpack_public_path__ + "static/media/male.33aa3d5d.png";